import type IExportRepository from '@/core/domain/exports/IExportRepository.ts'
import ExportFilterInput from '@/core/domain/exports/ExportFilterInput.ts'
import ExportResult from '@/core/domain/exports/ExportResult.ts'
import { ExportType } from '@/core/domain/resources/enums/ExportType.ts'

export default class FetchExportUseCase {
  private readonly exportRepository: IExportRepository

  constructor(exportRepository: IExportRepository) {
    this.exportRepository = exportRepository
  }

  async execute(key: ExportType.Values, filters: ExportFilterInput): Promise<ExportResult> {
    return this.exportRepository.fetchExport(key, filters)
  }
}